
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import image from '../../images/404.png'
import { ArrowBack } from '@mui/icons-material';


const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <Box display='flex' sx={{ height: '90vh' }} alignItems='center' justifyContent='center' flexDirection='column'>
      <Box>
        <img
          alt="Under development"
          src={image}
          style={{
            marginTop: 50,
            display: 'inline-block',
            maxWidth: '100%',
            width: 560
          }}
        />
      </Box>
      <Box mt={3}>
        <Button variant='contained' onClick={() => {
          navigate('/')
        }}
          startIcon={(<ArrowBack fontSize="small" />)}>
          Go back
        </Button>
      </Box>
    </Box>
  )
}

export default ErrorPage